var React = require('react');

function ArrowUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.9284 10.8616L8.61705 4.55028C8.2533 4.18653 7.66355 4.18653 7.2998 4.55028L0.988492 10.8616C0.624741 11.2253 0.624742 11.8151 0.988492 12.1788C1.35224 12.5426 1.942 12.5426 2.30575 12.1788L7.95843 6.52617L13.6111 12.1788C13.9749 12.5426 14.5646 12.5426 14.9284 12.1788C15.2921 11.8151 15.2921 11.2253 14.9284 10.8616Z"}));
}

ArrowUp.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = ArrowUp;

ArrowUp.default = ArrowUp;
